import { withRouter } from 'react-router-dom';
import { Icon, Switch } from '@mui/material';
import { useTaskTypes } from './useTaskTypes';
import { useScreen } from 'global/styles';
import { TaskTypeContainer } from './styles';
import { get, startCase } from 'global/lib/lodash';
import { uppercaseFirst } from 'global/utils';
import { CenterLoader } from 'global/styles';
import { FlexGridDataTable, FlexGridIconLabel, FlexGridListHint } from 'global/components/flex-grid-list';
import { getTaskTypeIcon } from '../../task/task-type-utils';

const formatHandleLabel = (handle = '') => startCase(String(handle).replace(/[-_]+/g, ' '));

export default withRouter((props) => {
  const { isMobile } = useScreen();
  const { data, loading, updateTaskType, enabledModeIds } = useTaskTypes();

  const isRowDisabled = (row) => {
    const modeOff = !enabledModeIds.includes(Number(row._appModeId));
    return !row.is_active || modeOff;
  };

  const onToggleEnabled = (row) => {
    updateTaskType(row.id, { enabled: !row.is_active });
  };

  const onSelectRow = (row) => {
    if (isRowDisabled(row)) return;
    props.history.push(`/account/content/task-type/${row.id}`, { from: 'account/content' });
  };

  if (loading && !data.length) return <CenterLoader />;

  const columns = [
    {
      field: 'enabled',
      title: 'Enabled',
      width: '10%',
      minWidth: 40,
      cellSx: { mr: { xs: 1, sm: 0 }, overflow: 'visible' },
      render: (row) => {
        const modeOff = !enabledModeIds.includes(Number(row._appModeId));
        return (
          <span onClick={(e) => e.stopPropagation()}>
            <Switch
              checked={row.is_active}
              onChange={() => onToggleEnabled(row)}
              size="small"
              color="primary"
              disabled={modeOff}
            />
          </span>
        );
      },
    },
    {
      field: 'mode',
      title: 'Mode',
      width: '12%',
      hideBelow: 'sm',
      render: (row) => get(row, 'mode', ''),
    },
    {
      field: 'name',
      title: 'Name',
      width: '28%',
      stackAt: 'sm',
      render: (row) => {
        const label = formatHandleLabel(row.handle) || row.name;
        return (
          <FlexGridIconLabel icon={<Icon fontSize="small">{getTaskTypeIcon(row)}</Icon>}>
            {label}
          </FlexGridIconLabel>
        );
      },
    },
    {
      field: 'custom_name',
      title: 'Custom Name',
      width: '25%',
      hideBelow: 'md',
      render: (row) => row.custom_name || '',
    },
    {
      field: 'location_types',
      title: 'Location Type(s)',
      width: '25%',
      hideBelow: 'md',
      render: (row) => (row.location_types || []).map(uppercaseFirst).join(', '),
    },
  ];

  return (
    <TaskTypeContainer isMobile={isMobile}>
      <FlexGridListHint />
      <FlexGridDataTable
        items={data || []}
        columns={columns}
        onSelectRow={onSelectRow}
        getRowProps={(row) => {
          const disabled = isRowDisabled(row);
          return {
            dimmed: disabled,
            ...(disabled ? { clickable: false, hover: false, onClick: undefined, style: { cursor: 'default' } } : null),
          };
        }}
      />
    </TaskTypeContainer>
  );
});